<template lang="html">
    <div class="content">
        <div class="image image-eye"></div>
        <p>
            Wij zijn een Vrijmetselaarsloge. Dat wil zeggen; een gezelschap van <a href="https://nl.wikipedia.org/wiki/Vrijdenkerij" target="_blank">vrij&shy;denk&shy;ende</a> mannen die met gepaste regel&shy;maat (iedere maandag&shy;avond) samen zijn om bewust te reflecteren op onze idee&euml;n, en onszelf, in de hoop en ver&shy;wach&shy;ting daar een 'beter' mens van te worden.
        </p>
        <hr />
        <div class="f-c">
            <div class="f-1">
                <div class="image image-broeders"></div>
                <pre>"Zeichnungen als Einsichten eines Frei - Maurers" ~ J.H. Puinbroek</pre>
            </div>
            <div class="f-1">
                <p class="question">
                    Waarom alleen mannen?
                </p>
                <p>
                    Mannen en vrouwen zijn wel&shy;is&shy;waar ge&shy;lijk&shy;waardig, maar ze zijn geens&shy;zins gelijk.
                </p>
                <p>
                    Mocht u, als vrouw, op zoek zijn naar een loge dan doet het u vast deugd te weten dat er ook loges waarin zowel mannen als vrouwen - alsook loges waarin enkel vrouwen toegelaten wor&shy;den - bestaan.
                </p>
                <p>
                    Bij Loge La Force treft u echter enkel mannen.
                </p>
            </div>
        </div>
        <hr />
        <div class="f-c">
            <div class="f-1">
                <p class="concern">
                    Vanwaar al die geheimzinnigheid?
                </p>
                <p>
                    Misschien heeft u allerlei span&shy;nende ver&shy;halen ge&shy;hoord over de Vrij&shy;metselarij. Over ver&shy;borgen wereld&shy;heerschappij en an&shy;dere duistere complot&shy;theorie&euml;n.
                </p>
                <p>
                    Of over het <a href="https://www.vice.com/nl/article/7xk5zz/een-avondje-undercover-naar-een-bijeenkomst-van-de-vrijmetselaars?ref=logelaforce.nl" target="_blank">'drin&shy;ken van bloed uit sche&shy;dels'</a> en bent u en&shy;kel op zoek naar meer in&shy;for&shy;matie om uw donker&shy;bruine ver&shy;moedens be&shy;vestigd te zien?
                </p>
                <p>
                    In dat ge&shy;val raden wij u met klem aan niet zomaar alles voor waar&shy;heid aan te nemen.
                </p>
            </div>
            <div class="f-1">
                <p class="concern">
                    Hoe gaat het er dan aan toe in zo'n loge?
                </p>
                <p>

                </p>
                <p>
                    Als u be&shy;nieuwd bent hoe het er in een loge aan toe gaat, dan kunt u het best eens een keer langs&shy;komen.
                    <!-- <br /> -->
                    <!-- <br /> -->
                    <!-- De eerstvolgende avond voor belangstellenden is op <u>2 oktober 2023</u>! -->
                </p>
                <p class="answer">
                    U bent van harte wel&shy;kom. Meld u aan met de knop en vermeldt uw naam en eventueel uw telefoonnummer.
                </p>
                <div>
                    <a class="button" href="mailto:logelaforce@gmail.com?subject=Ik%20wil%20een%20keertje%20op%20bezoek%20komen">Nu aanmelden</a>
                </div>
            </div>
        </div>
        <hr />
        <div class="f-c">
            <div class="f-1">
                <p class="question">
                    Kan iedereen zomaar lid worden?
                </p>
                <p>
                    Nee, in principe volstaat het 'een vrij man van goede naam' te zijn maar daar blijft het niet bij...
                </p>
                <p>
                    Wat mo&shy;tiveert u? Wat brengt u naar de loge? In welke mate to&shy;lereert u andere (levens)over&shy;tuigingen?
                </p>
                <p class="answer">
                    Als iemand besluit zich aan te melden voor lid&shy;maatschap vraagt de 'Commissie van On&shy;der&shy;zoek' deze en meer van dit soort vragen.
                </p>
                <!-- <p class="answer">
                    En niet zonder reden; daarmee behouden we de sfeer van wederzijds ver&shy;trouwen en respect die van vitaal belang is voor de harmonie in onze Loge.
                </p> -->
            </div>
            <div class="f-1">
                <div class="image image-spiegel"></div>
                <pre> "Zeichnungen als Einsichten eines Frei - Maurers" ~ J.H. Puinbroek </pre>
            </div>
        </div>
        <p class="quote">
            "De waarheid is relatief. Iedereen verstaat er iets anders onder." <span class="author">~ Broeder Redenaar.</span>
        </p>
        <Proceedings></Proceedings>
    </div>
</template>

<script>

import Proceedings from './Proceedings'

export default {
    name: 'Intro',
    components: {
        Proceedings
    },
    methods: {
        requestAppointment () {

        }
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0
    }
}
</script>

<style lang="css" scoped>
    .image-eye {
        background: transparent url('/images/eye-dollar.jpg') no-repeat center -160px;
        background-size: cover;
        height: 260px;
        margin-top: 30px;
    }
    .image-broeders {
        background: transparent url('/images/broeders.png') no-repeat center -40px;
        background-size: cover;
        height: 360px;
        position: relative;
        /* border-bottom: solid 1px #333; */
    }
    .image-spiegel {
        background: transparent url('/images/spiegel.png') no-repeat top center;
        background-size: cover;
        height: 360px;
    }
</style>
